import Vue from 'vue'

// Log unhandled errors to console
// Note that the Sentry plugin reports these
Vue.config.errorHandler = (err: Error, _vm: Vue, lifecycleHook: string) => {
  console.warn(`Uncaught error in "${lifecycleHook}" lifecycle hook`)
  console.error(err.stack)
}
